import React, { createContext, useContext, ReactNode } from "react";
import { WindowLocation } from "@reach/router";

const LocationContext = createContext<WindowLocation | undefined>(undefined);

interface LocationProviderProps {
  location: WindowLocation;
  children: ReactNode;
}

export const LocationProvider = ({
  location,
  children
}: LocationProviderProps) => (
  <LocationContext.Provider value={location}>
    {children}
  </LocationContext.Provider>
);

export const useGatsbyLocation = () => {
  const location = useContext(LocationContext);
  if (!location) {
    throw new Error(
      "LocationProvider must be used to rely on useGatsbyLocation."
    );
  }
  return location;
};
